import { MenuItem, Stack, Typography } from "@mui/material";
import { type FC } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";

interface SeeDetailsMenuItemProps {
	readonly internalUniqueId: string;
}

export const SeeDetailsMenuItem: FC<SeeDetailsMenuItemProps> = ({ internalUniqueId }) => {
	const navigate = useNavigate();

	return (
		<MenuItem
			onClick={() => {
				navigate(`/search/${internalUniqueId}`);
			}}
		>
			<Stack gap={1} direction="row" alignItems="center">
				<SearchIcon fontSize="small" />
				<Typography variant="body2">
					<FormattedMessage id="See Details" defaultMessage="See Details" />
				</Typography>
			</Stack>
		</MenuItem>
	);
};
